import { regFlow } from "@/constants/common";
import { EventTrackingProps } from "@/types/common";
import { Details } from "@/types/userDetails";
import { createContext, useContext } from "react";

export const RegistrationContext = createContext({
  details: {} as Details,
  screenType: "",
  setDetails: (details: any) => {},
  handleOnSubmit: (data?: any, nextAction?: string, trackingObj?: {}) => {},
  translation: {} as any,
  handleEventTracking: (props: EventTrackingProps) => {},
  setToast: (toast: any) => {},
  progressPercent: 0,
  getNextAction: () => {},
  isSkipabl: false,
  isLoading: false,
  setIsLoading: (loading: boolean) => {},
  isJobApplied: false,
  setIsJobApplied: (isJobApplied: boolean) => {},
  handleScreenChange: (
    nextAction: string,
    profileProgress?: number,
    isSkipabl?: boolean,
    data?: any,
  ) => {},
  isApp: false,
  flowType: regFlow,
  jobDetailUrlForSprWithId: "",
  hostname: "",
});

export function useRegistrationProps() {
  return useContext(RegistrationContext);
}
